<template>
    <div class="formulate-tag-selector">
        <v-select ref="select" :class="`formulate-input-element formulate-input-element--${context.type}`" :data-type="context.type" :modelValue="selectedValue" @update:modelValue="handleInput" :options="options" :taggable="canCreateTag" :multiple="true" :filterable="true" :clearable="false" :closeOnSelect="true" :clearSearchOnSelect="true" :create-option="createOption" @option:created="onAddTag" @search="onSearch" @close="onClose" label="label" :loading="loading" placeholder="- Selecteer -">
            <template #selected-option-container>
                <span class="noRender"></span>
            </template>

            <template #option="{ label, uuid }">
                <div class="formulate-tag-selector__option">
                    <span class="option-label" v-if="label" v-html="label"></span>
                    <span v-if="!uuid">(nieuwe fractie aanmaken)</span>
                </div>
            </template>

            <template #search="{ attributes, events }">
                <input placeholder="- Selecteer -" class="vs__search" v-bind="attributes" v-on="events" />
            </template>

            <template #no-options>
                <span v-if="emptyMessageText" v-html="emptyMessageText"></span>
                <span v-else> Zoek een tag of maak een nieuwe aan. </span>
            </template>
        </v-select>
        <div class="formulate-tag-selector__options">
            <div v-for="option in selectedValue" :key="option.uuid || option.value || option.label" class="button--option button" @click="onOptionClick(option)">
                <span class="icon icon--cross icon--dark">remove</span>
                {{ option.label || option.name || option.title }}
            </div>
        </div>
    </div>
</template>

<script src="./FormulateTagField.js"></script>
